import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { FundsInformFieldsAsset, InvestorInformation } from "../partials/FormFields";
import { Backdrop } from "@mui/material";
import ActivateAdminRequest from "./ActivateAdminRequest";
import { useDispatch, useSelector } from "react-redux";
import { toggleActivateRequestModal } from "../ApprenticeshipSlice";
import { ApprenticeLists } from "../partials/ApprenticeLists";

const InvestorRequestForm = ({ AFdata, setAFdata, updateCurrentObject }) => {
	const dispatch = useDispatch();
	const { activateRequestModal } = useSelector((state) => state.apprenticeship);
	const [activateAssetTab, setActivateAssetTab] = useState(1);
	const [formData, setFormData] = useState(AFdata);
	const [action, setAction] = useState("view");

	const isEditable = action === "edit" && AFdata?.type === "quick" && AFdata?.status === "inactive";
	// console.log(isEditable);

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const canActivateAsset = AFdata?.type === "quick" && AFdata?.status === "inactive" ? true : false;

	const handleCancel = () => {
		setFormData(AFdata);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		setAFdata(formData);
		updateCurrentObject(formData);
	};

	const onBeginActivateRequest = () => {
		dispatch(toggleActivateRequestModal(true));
		setActivateAssetTab(1);
	};

	return (
		<>
			<Backdrop open={activateRequestModal} sx={{ zIndex: 13 }}>
				<ActivateAdminRequest
					activateAssetTab={activateAssetTab}
					setActivateAssetTab={setActivateAssetTab}
					requestData={AFdata}
				/>
			</Backdrop>

			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					AFdata={formData}
					handleCancel={handleCancel}
					action={AFdata?.status === "inactive" && AFdata?.type === "quick" ? action : ""}
					setAction={setAction}
					canActivateAsset={canActivateAsset}
					handleRequestActivation={onBeginActivateRequest}
				/>

				<div className='RightSection'>
					<FormAccordion title='Funds Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<FundsInformFieldsAsset
								formData={formData}
								isEditable={isEditable}
								handleInputChange={handleInputChange}
								except={["approvalStatus", "disbursement"]}
							/>
						</div>
					</FormAccordion>

					<FormAccordion title='Investor’s Information' open={true}>
						<InvestorInformation formData={formData} />
					</FormAccordion>

					{formData?.status !== "inactive" && (
						<FormAccordion title='Apprentices List' open={true}>
							{formData?.apprentice?.length > 0 ? (
								<ApprenticeLists apprenticesList={formData?.apprentice} requestData={formData} />
							) : (
								<p style={{ fontWeight: "500" }}>No apprentice has requested this finance yet.</p>
							)}
						</FormAccordion>
					)}

					{/* <FormAccordion title='Identification' open={true}>
          <div className='grid grid-cols-3 gap-3'>
            <IdentificationGroup formData={formData} />
          </div>
        </FormAccordion> */}

					{/* <FormAccordion title='Power of Attorney' open={true}>
          <div className='grid grid-cols-3 gap-3'>
            <div className='form-group'>
              <SelectFieldStatus
                name='powerOfAttorney'
                handleChange={handleInputChange}
                value={formData?.powerOfAttorney}
                type={formData?.powerOfAttorney ? "success" : "error"}
              />
            </div>
          </div>
        </FormAccordion> */}
				</div>
			</StyledForm>
		</>
	);
};

InvestorRequestForm.propTypes = {
	AFdata: PropTypes.object,
	setAFdata: PropTypes.func,
	updateCurrentObject: PropTypes.func,
};

export default InvestorRequestForm;
